import { InvoiceEditorVariant } from '../../enums/invoiceEditorVariant'

export const invoiceEditorFromQuoteVariants: InvoiceEditorVariant[] = [
  InvoiceEditorVariant.DepositInvoiceNewFromQuote,
  InvoiceEditorVariant.FinalInvoiceNewFromQuote,
  InvoiceEditorVariant.InvoiceNewFromQuote,
]
